import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CartProvider } from "./contexts/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminQuotesPage from "./pages/AdminQuotesPage";
import AdminContactsPage from "./pages/AdminContactsPage";
import AdminRequestsPage from "./pages/AdminRequestsPage";
import PhotoStudioPage from "./pages/PhotoStudioPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CategoryPricingPage from "./pages/CategoryPricingPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import OrderCancelledPage from "./pages/OrderCancelledPage";
import CustomRequestPage from "./pages/CustomRequestPage";
import BoneyardPage from "./pages/BoneyardPage";
import StickyWicketPage from "./pages/StickyWicketPage";
import { StickersLandingPage, BlindBagPage, ThemePackPage, DecalsPage, DecalCategoryPage, DecalDetailPage } from "./pages/StickerShopPages";
import { refreshDynamicCategories } from "./lib/dynamicCatalog";

function App() {
    const [catalogReady, setCatalogReady] = useState(false);

    useEffect(() => {
        refreshDynamicCategories().finally(() => setCatalogReady(true));
    }, []);

    if (!catalogReady) {
        // Brief, same-origin fetch — usually resolves in well under a second.
        return <div className="App min-h-screen bg-storm-void" />;
    }

    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/custom-request" element={<CustomRequestPage />} />
                            <Route path="/admin" element={<AdminPage />} />
                            <Route path="/admin/orders" element={<AdminOrdersPage />} />
                            <Route path="/admin/quotes" element={<AdminQuotesPage />} />
                            <Route path="/admin/contacts" element={<AdminContactsPage />} />
                            <Route path="/admin/requests" element={<AdminRequestsPage />} />
                            <Route path="/admin/photo-studio" element={<PhotoStudioPage />} />
                            <Route path="/admin/pricing" element={<CategoryPricingPage />} />
                            <Route path="/admin/boneyard" element={<BoneyardPage />} />
                            <Route path="/admin/sticky-wicket" element={<StickyWicketPage />} />
                            <Route path="/order/success" element={<OrderSuccessPage />} />
                            <Route path="/order/cancelled" element={<OrderCancelledPage />} />
                            <Route path="/shop/:category/:sub/:listingSlug" element={<ProductDetailPage />} />
                            {/* Sticker & decal storefront (static paths win over the generic :category routes) */}
                            <Route path="/stickers" element={<StickersLandingPage />} />
                            <Route path="/stickers/blind-bag" element={<BlindBagPage />} />
                            <Route path="/stickers/:slug" element={<ThemePackPage />} />
                            <Route path="/vinyl-decals" element={<DecalsPage />} />
                            <Route path="/vinyl-decals/category/:category" element={<DecalCategoryPage />} />
                            <Route path="/vinyl-decals/item/:id" element={<DecalDetailPage />} />
                            <Route path="/:category" element={<CategoryPage />} />
                            <Route path="/:category/:sub" element={<CategoryPage />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </CartProvider>
        </div>
    );
}

export default App;
